module.exports = eval("try{require('tls')}catch(e){}");